import { useInjection } from "@linkfluence/core/di";
import { Locale } from "@linkfluence/models/locale";
import { useQuery } from "@tanstack/react-query";
import { AISummary } from "@radarly/models/ai";
import { DatavizTypeAI } from "@radarly/models/dataviz";
import { AIFragment } from "@radarly/models/search";
import { AiRepo, AiRepositoryUID } from "../repositories/AiRepo";

export const AI_SUMMARY_QUERY_KEY = ({
  pid,
  analysis,
  context,
  request,
  locale,
}: {
  pid: number;
  analysis: AIFragment["analysis"];
  context: AIFragment["context"];
  request: AIFragment["request"];
  locale: Locale;
}) => ["/ai/summary", { pid, analysis, context, request, locale }];

export function useAISummary<T extends DatavizTypeAI>(
  pid: number,
  searchFragmentAI: AIFragment & { analysis: { type: T } },
  previousLocale: Locale
) {
  const repository = useInjection<AiRepo>(AiRepositoryUID);
  const { analysis, request, context } = searchFragmentAI;

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery<
    AISummary<T>
  >(
    AI_SUMMARY_QUERY_KEY({
      pid,
      analysis,
      context,
      request,
      locale: previousLocale,
    }),
    () => {
      return repository.getAISummary(pid, { ...searchFragmentAI });
    },
    {
      retry: 1, // Prevent retries when we get a "Not enough posts" error
      staleTime: 60 * 1000,
    }
  );

  return {
    data,
    refetch,
    isFetching,
    isLoading,
    isError,
    error,
  };
}
